import React from 'react'
import { XStack, YStack } from 'tamagui'

import { Card } from '@newComponents/Card'
import { Icon } from '@newComponents/Icon'
import { Paragraph } from '@newComponents/Text'
import { Link } from '@newComponents/Link'

import { DocSection } from '../shared/DocSection'
import { DocScreenshot } from '../shared/DocScreenshot'

const Discounts = () => (
  <>
    <Card gap='$4'>
      <Paragraph size='$5'>
        Discount codes let you offer reduced pricing on Event tickets. They are
        ideal for early bird promotions, sponsor giveaways, group discounts, or
        rewarding loyal community Members.
      </Paragraph>
      <DocScreenshot
        src='docs/events/event-page.png'
        alt='Event page showing the checkout flow where attendees can apply discount codes during ticket purchase'
        caption='Attendees apply discount codes during the checkout flow on the Event page'
      />
    </Card>

    <Card gap='$4'>
      <DocSection id='discount-configuration' title='Discount Configuration'>
        <YStack gap='$3'>
          <XStack gap='$3' alignItems='flex-start'>
            <Icon name='ribbon-filled' size='$5' color='$color' flexShrink={0} marginTop={2} />
            <Paragraph size='$5'>
              <Paragraph size='$5' fontWeight='$7'>Creating a discount code</Paragraph>{' '}
              — Open{' '}
              <Link href='/docs/events/settings'>Event Settings</Link> and go to the
              Tickets section. Click{' '}
              <Paragraph size='$5' fontWeight='$7'>Add Discount Code</Paragraph> to
              create a new code. Enter a code name that attendees will type during
              checkout (for example, EARLYBIRD or COMMUNITY20).
            </Paragraph>
          </XStack>
          <XStack gap='$3' alignItems='flex-start'>
            <Icon name='money' size='$5' color='$color' flexShrink={0} marginTop={2} />
            <Paragraph size='$5'>
              <Paragraph size='$5' fontWeight='$7'>Discount types</Paragraph> — Choose
              between a percentage-based discount (e.g., 20% off) or a fixed-amount
              discount (e.g., $10 off). Percentage discounts are applied to the tier
              price, while fixed-amount discounts subtract a flat amount from the
              total.
            </Paragraph>
          </XStack>
          <XStack gap='$3' alignItems='flex-start'>
            <Icon name='people' size='$5' color='$color' flexShrink={0} marginTop={2} />
            <Paragraph size='$5'>
              <Paragraph size='$5' fontWeight='$7'>Usage limits</Paragraph> — Set a
              maximum number of times the code can be used. For example, you can create
              a code that is limited to the first 50 uses, making it useful for
              limited-time promotions. Once the limit is reached, the code
              automatically stops working.
            </Paragraph>
          </XStack>
          <XStack gap='$3' alignItems='flex-start'>
            <Icon name='ticket-diagonal' size='$5' color='$color' flexShrink={0} marginTop={2} />
            <Paragraph size='$5'>
              <Paragraph size='$5' fontWeight='$7'>Tier restrictions</Paragraph> —
              Optionally restrict a discount code to specific{' '}
              <Link href='/docs/events/tiers'>ticketing tiers</Link>. For example, you
              can create a 20% early bird code that only applies to General Admission
              tickets but not to VIP tickets. If no restriction is set, the code
              applies to all paid tiers.
            </Paragraph>
          </XStack>
        </YStack>
      </DocSection>
    </Card>

    <Card gap='$4'>
      <DocSection id='applying-discounts' title='Applying Discounts'>
        <Paragraph size='$5'>
          Attendees apply discount codes during the{' '}
          <Link href='/docs/events/purchase-flow'>checkout flow</Link>. The
          discount is reflected in the payment breakdown before they confirm their
          purchase, so attendees can see exactly how much they are saving.
        </Paragraph>
      </DocSection>
    </Card>
  </>
)

export default Discounts
